
import React from 'react';
import data from '../../../utils/dbSchema';
import Layout from '../../Layout';
import { Box, Wrapper } from '../../UI';
import PageTitle from '../../Layout/PageTitle';
import LoisHeader from './LoisHeader';
import LoisTable from './LoisTable';

export default function Dashboard({ match, history }) {
	const { path } = match;
	const propertyData = data.properties.find(property => {
		return match.params.id === property.id;
	});

	return (
		<Layout path={path} history={history}>
			<Box p="30px">
				<Wrapper>
                    <PageTitle title='Letter of Intent Report'/>
                    <LoisHeader id={propertyData.id}/>
                    <Box mt='2rem'>
                        <LoisTable  id={propertyData.id}/>
                    </Box>
				</Wrapper>
			</Box>
		</Layout>
	);
}
